import { render, staticRenderFns } from "./Indexrtl.vue?vue&type=template&id=5ec821ba"
import script from "./Indexrtl.vue?vue&type=script&lang=js"
export * from "./Indexrtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports